import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import HomePage from './pages/Home';
import CertificationsPage from './pages/CertificationsPage';
import AwardsPage from './pages/AwardsPage';
import ProjectsPage from './pages/ProjectsPage';
import MemoriesPage from './pages/MemoriesPage';
import DetailsPage from './pages/DetailsPage';
import ExperienceComponent from './pages/Experience';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <HomePage />
      },
      {
        path: "/experience",
        element: <ExperienceComponent />
      },
      {
        path: "/certifications",
        element: <CertificationsPage />
      },
      {
        path: "/awards",
        element: <AwardsPage />
      },
      {
        path: "/projects",
        element: <ProjectsPage />
      },
      {
        path: "/memories",
        element: <MemoriesPage />
      },
      {
        path: "/details/:of/:id",
        element: <DetailsPage />
      },
      {
        path: "*",
        element: <HomePage />
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
